import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react'

type Ctx = {
  activeMenuId: string | null
  setActiveMenuId: (id: string | null) => void
}

const TopBarMenuContext = createContext<Ctx | null>(null)

export const TopBarMenuProvider = ({ children }: { children: ReactNode }) => {
  const [activeMenuId, setActiveMenuId] = useState<string | null>(null)
  const value = useMemo(() => ({ activeMenuId, setActiveMenuId }), [activeMenuId])
  return <TopBarMenuContext.Provider value={value}>{children}</TopBarMenuContext.Provider>
}

export const useTopBarMenu = (id: string) => {
  const ctx = useContext(TopBarMenuContext)
  if (!ctx) throw new Error('useTopBarMenu must be used inside TopBarMenuProvider')
  const isOpen = ctx.activeMenuId === id
  const setIsOpen = useCallback((next: boolean) => ctx.setActiveMenuId(next ? id : null), [ctx, id])
  return { isOpen, setIsOpen }
}
